import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/mail_gray_60.png'
import _imports_1 from '@/assets/icons/person_gray_150.png'


const _withScopeId = n => (_pushScopeId("data-v-08f5be85"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "alert alert-primary alert-sm"
}
const _hoisted_2 = { class: "sharing-limit" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Sharing limit:", -1))
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { class: "count" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Currently sharing with:", -1))
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "count" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "help-text-sm" }, " This is the total number of unique users or invited users in all the groups you own, except groups that are only sharing trees that are \"free to share\". ", -1))
const _hoisted_10 = { class: "list-unstyled" }
const _hoisted_11 = {
  key: 0,
  src: _imports_0,
  class: "invite-icon"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "user-icon"
}, null, -1))

import { computed, onMounted, ref } from 'vue'
import { useUserStore } from '@/gp/UserStore'
import { SharingUser, useSharingLimiter } from './SharingLimiter'
import { useModalAutoHide } from '@/util/AppUtil'
import Modal from '@/util/Modal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SharingLimitModal',
  setup(__props) {

const sharingUsersRef = ref<SharingUser[]>([])
const modalRef = ref<InstanceType<typeof Modal>>()

const userStore = useUserStore()
const sharingLimiter = useSharingLimiter()

useModalAutoHide(modalRef)

const selfUserRef = computed(() => userStore.getAsyncSelf()?.data)
const sharingLimitRef = computed(() => selfUserRef.value?.limits?.sharingLimit ?? 0)
const remainingRef = computed(() => Math.max(0, sharingLimitRef.value - sharingUsersRef.value.length))
const sharingLimitReachedRef = computed(() => sharingUsersRef.value.length >= sharingLimitRef.value)

async function onShown() {
  // ensure we have the right #'s each time the modal is shown
  sharingUsersRef.value = await sharingLimiter.getSharingUsersAsync()
  sharingUsersRef.value.sort((a, b) => a.displayName.localeCompare(b.displayName))
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    class: "sharing-limit-modal",
    info: "",
    onShown: onShown
  }, {
    title: _withCtx(() => [
      _createTextVNode(" Current sharing ")
    ]),
    secondaryText: _withCtx(() => [
      _createTextVNode(" Learn about sharing limits ")
    ]),
    default: _withCtx(() => [
      (sharingLimitReachedRef.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createTextVNode(" You have reached your sharing limit. "),
            _createVNode(_component_router_link, { to: "/plans" }, {
              default: _withCtx(() => [
                _createTextVNode("Upgrade")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(sharingLimitRef.value), 1),
          _createTextVNode(" users ")
        ]),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(sharingUsersRef.value.length), 1),
          _createTextVNode(" users ")
        ]),
        _hoisted_9
      ]),
      _createElementVNode("ul", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sharingUsersRef.value, (u) => {
          return (_openBlock(), _createElementBlock("li", {
            key: u.userId ?? u.inviteId!,
            class: _normalizeClass({ invited: u.invited })
          }, [
            _createElementVNode("div", null, [
              (u.invited)
                ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                : _createCommentVNode("", true),
              _hoisted_12,
              _createTextVNode(" " + _toDisplayString(u.displayName), 1)
            ])
          ], 2))
        }), 128))
      ])
    ]),
    _: 1
  }, 512))
}
}

})